import React, { useEffect, useState, useRef } from "react";
import { useDataProvider } from "../../api/DataProvider";
import "../../styles/devices/mob_SignDialog.css";
import Button from "@mui/material/Button";
import ReactPlayer from "react-player";
import VideocamIcon from '@mui/icons-material/Videocam';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import { IconButton } from '@mui/material';
import { pDataProvider } from "../../utils/parameters";
import { useTranslation } from "react-i18next";

import Paper from "@mui/material/Paper";
import { Tooltip, withStyles } from '@material-ui/core';

const SHOW_OVERLAY = 0
const SHOW_KEYPOINTS = 1

export default function DialogDetail(props) {
  const { t } = useTranslation("global")
  
  const { elements_requested, elements_response } = props;
  const { comm_getPublicURLVideoData } = useDataProvider();

  const [ counter_element_actived, setCounter_element_actived ] = useState(0);
  // const video_overlay_ref = useRef(null);
  // const video_keypoint_ref = useRef(null);

  const [video_overlay_ref, setVideo_overlay_ref] = useState(null);
  const [video_keypoint_ref, setVideo_keypoint_ref] = useState(null);

  const [ show_video, setShow_video ] = useState(SHOW_OVERLAY); // 0: Overlay, 1: Keypoints
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [ success, setSuccess ] = useState(true);

  const [dataShow, setDataShow] = useState({
    'url_vid_keypoints': '',
    'url_vid_overlay': '',
    'lemma_requested': '',
    'lemma_user': '',
    'hits': 0,
    'model':  {
      'lemma': 0,
      'probability': 0,
    },
  });

  // useEffect(() => { 
  //   console.log("useEffect");
  //   console.log(elements_requested);
  //   console.log(elements_response);
  // }, []);


  useEffect(() => {

    // console.log('elements_response', elements_response)

    if (elements_response.hits.length > 0) {
      // console.log('elements_response', elements_response)

      const newDataShow = {
        'url_vid_keypoints': comm_getPublicURLVideoData(pDataProvider.dir_vid_versusKeypoints, elements_requested[counter_element_actived].gloss_id),
        'url_vid_overlay': comm_getPublicURLVideoData(pDataProvider.dir_vid_versusOverlay, elements_requested[counter_element_actived].gloss_id),
        'lemma_requested': elements_response['arr_lemmas_request'][counter_element_actived],
        'lemma_user': elements_response['arr_lemmas_annotated'][counter_element_actived],
        'hits': elements_response['hits'][counter_element_actived],
        'model': elements_requested[counter_element_actived].model
      }

      setDataShow(newDataShow)
    }
  }, [elements_response, counter_element_actived]);

  // useEffect(() => {
  //   console.log('dataShow', dataShow)
  // }, [dataShow]);



  const clickBtnNext = () => {
    if (counter_element_actived < 10) {
      const new_counter_element_actived = counter_element_actived + 1
      setCounter_element_actived(new_counter_element_actived)
      setShow_video(SHOW_OVERLAY)
    }
  };

  const clickBtnBack = () => {
    if (counter_element_actived > 0) {
      const new_counter_element_actived = counter_element_actived - 1
      setCounter_element_actived(new_counter_element_actived)
      setShow_video(SHOW_OVERLAY)
    }
  };

  // function onLoadedDef() {
  //   // setVideoLoaded(true);
  //   console.log("onLoadedDef");
  // }

  return (
    <>
      <div className='sig_SignModal_CarouselContainer'>
      <div className="sig_Hub_InfoTitle sig_Hub_InfoSubTitle sig_VersusMachine_ResultsTop">

        {show_video === SHOW_OVERLAY ? 
        <>
          <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_OVERLAY)} disabled={show_video === SHOW_OVERLAY} > 
            <VideocamIcon fontSize="medium" color={(show_video == SHOW_OVERLAY) ? 'disabled' : 'primary'}/> 
          </IconButton>
        </> 
        : 
        <>
          <Tooltip title={t("sTooltip.show_overlay")} placement="bottom" arrow>
            <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_OVERLAY)} disabled={show_video === SHOW_OVERLAY} > 
              <VideocamIcon fontSize="medium" color={(show_video == SHOW_OVERLAY) ? 'disabled' : 'primary'}/> 
            </IconButton>
          </Tooltip>
        </>
        } 

        {(dataShow.hits) ? (
            <span className="sig_VersusMachine_ResponseStatus_Success" > {t("sFilter.success").toUpperCase()} </span>
          ) : (
            <span className="sig_VersusMachine_ResponseStatus_Failure" > {t("sFilter.failure").toUpperCase()} </span>
          )
        }

        {show_video === SHOW_KEYPOINTS ? 
        <>
          <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_KEYPOINTS)} disabled={show_video === SHOW_KEYPOINTS}> 
            <EmergencyRecordingIcon fontSize="medium" color={(show_video == SHOW_KEYPOINTS) ? 'disabled' : 'primary'}/> 
          </IconButton>
        </> 
        : 
        <>
          <Tooltip title={t("sTooltip.show_keypoints")} placement="bottom" arrow>
            <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_KEYPOINTS)} disabled={show_video === SHOW_KEYPOINTS}> 
              <EmergencyRecordingIcon fontSize="medium" color={(show_video == SHOW_KEYPOINTS) ? 'disabled' : 'primary'}/> 
            </IconButton>
          </Tooltip>
        </>
        } 

      </div>

      <div>
        <ReactPlayer
          width="80%"
          height="80%"
          className="sig_VersusMachine_videoDetailDialog"
          url={ (show_video == SHOW_OVERLAY) ? dataShow.url_vid_overlay : dataShow.url_vid_keypoints }
          controls={false}
          playing={true}
          onReady ={onLoadedDef}
          loop={true}
        />
      </div>


      </div>
      <div className="sig_Hub_InfoTitle sig_Hub_InfoSubTitle">
        <Button onClick={clickBtnBack}>
          {" "}
          <ArrowCircleLeftRoundedIcon className={`sig_VersusMachine_Arrow_Button ${counter_element_actived == 0 ? "sig_VersusMachine_Arrow_Button_Hide" : ""}`} />{" "}
        </Button>
        <span className="sig_VersusMachine_Counter">{counter_element_actived + 1} de 10</span>
        <Button onClick={clickBtnNext}>
          <ArrowCircleRightRoundedIcon className={`sig_VersusMachine_Arrow_Button ${counter_element_actived == 9 ? "sig_VersusMachine_Arrow_Button_Hide" : ""}`} />
        </Button>
      </div>



      <div className="sig_SignModal_Sign">
        <Paper elevation={3} className="sig_VersusMachine_PaperInfo">
          <div className="sig_SignModal_PaperInfo">
            <div className="sig_SignModal_PaperLine">
              <span className="sig_VersusMachine_InfoTitle">Término propuesto: </span>
              <span className="sig_VersusMachine_InfoContent">{dataShow["lemma_requested"]}</span>
            </div>
            <div className="sig_SignModal_PaperLine">
              <span className="sig_VersusMachine_InfoTitle">La respuesta del usuario ha sido: </span>
              <span className="sig_VersusMachine_InfoContent">{dataShow["lemma_user"]}</span>
            </div>

            {dataShow["model"]["top"] > 0 ? (
              <>
                <div className="sig_SignModal_PaperLine">
                  <span className="sig_VersusMachine_InfoTitle">La máquina detectó:</span>
                  <span className="sig_VersusMachine_InfoContent"> El término "{dataShow["lemma_requested"]}" como {dataShow["model"]["top"]}º opción con una probabilidad del {(dataShow["model"]["prob"]*100).toFixed(2)}%</span>
                </div>
              </>
            ) : (
              <>
                <div className="sig_SignModal_PaperLine">
                  <span className="sig_VersusMachine_InfoTitle">Máquina</span>
                  <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="bottom"
                    arrow
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p>
                          La máquina todavía no es capaz de reconocer este signo. Para aprender, necesita ver muchos vídeos que contengan ese signo para aprender a reconocerlo.
                        </p>
                        <p><strong>¡Colabora aportando grabaciones para enseñarle LSE!</strong></p>
                      </div>
                    }
                  >
                    <span className="sig_VersusMachine_InfoContent">Término no disponible.*</span>
                  </Tooltip>
                </div>
              </>
            )}
          </div>
        </Paper>
      </div>
    </>
  );
}
